if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

onSubmitHandler(evt) {
    // 1. 【第一步】阻止默认提交
    evt.preventDefault();
    
    // 2. 【核心校验】(保持稳定版逻辑不变)
    const fileInput = document.getElementById('custom-image-prop');
    const textInput = document.getElementById('custom-text-prop');
    const errorMsg = document.getElementById('custom-image-error');
    const triggerBox = document.querySelector('.js-trigger-box') || document.getElementById('upload-trigger-box');

    // === 新增：获取容器 ===
    const uploadWrapper = document.getElementById('js-custom-upload-wrapper');

    // 2. 必填校验 (带条件)
    // 只有当：文件框存在 且 容器是可见的 (offsetParent !== null) 时，才拦截
    if (fileInput && uploadWrapper && uploadWrapper.offsetParent !== null) {
    // 必填拦截
    if (fileInput && fileInput.files.length === 0) {
      evt.stopPropagation();
      evt.stopImmediatePropagation();
      
      if (errorMsg) errorMsg.style.display = 'flex';
      
      if (triggerBox) {
        triggerBox.style.borderColor = '#d04343';
        triggerBox.style.backgroundColor = '#fff0f0';
        setTimeout(() => { triggerBox.style.backgroundColor = '#fff'; }, 1000);
      } else {
        fileInput.style.borderColor = '#d04343';
      }

      fileInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false; 
    } else {
      if (errorMsg) errorMsg.style.display = 'none';
      if (triggerBox) triggerBox.style.borderColor = '#ccc';
    }
  }

    // 3. UI Loading 状态
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    
    const defaultText = submitButton.querySelector('span');
    let originalButtonText = "";
    if (defaultText) {
        originalButtonText = defaultText.textContent;
        defaultText.textContent = "Uploading...";
    }
    const spinner = this.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    // 4. 构建数据
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    // =========================================================
    // 🔴 数量修复核心：从 Form 外部抓取数量 🔴
    // =========================================================
    // 1. 先尝试在 form 内部找
    let qtyInput = this.form.querySelector('input[name="quantity"]');
    
    // 2. 如果没找到，或者 form ID 存在，尝试通过 ID 在全局找 (这是 Dawn 最常见的情况)
    if (!qtyInput && this.form.id) {
        qtyInput = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
    }

    // 3. 如果还是没找到，尝试找页面上第一个可见的数量框 (兜底)
    if (!qtyInput) {
        qtyInput = document.querySelector('input[name="quantity"]');
    }
    
    // 4. 写入 FormData
    if (qtyInput) {
        formData.set('quantity', qtyInput.value);
        // console.log("Quantity Fixed:", qtyInput.value); // 调试：你可以打开控制台看这个数值对不对
    }
    // =========================================================

    // 5. 移除冲突参数
    formData.delete('sections');
    formData.delete('sections_url');

    // 6. 追加自定义属性
    if (fileInput && fileInput.files.length > 0) {
      formData.append('properties[Custom Image]', fileInput.files[0]);
    }
    if (textInput && textInput.value) {
      formData.append('properties[Custom Text]', textInput.value);
    }

    config.body = formData;

    // 7. 发送请求
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => {
        if (!response.ok) {
            return response.json().then(err => { throw new Error(err.description || 'Add failed'); });
        }
        return response.json();
      })
      .then((response) => {
        // 8. 成功后拉取抽屉 HTML
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((res) => res.text())
          .then((responseText) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            
            const cartDrawer = document.querySelector('cart-drawer');
            const targetContent = document.querySelector('#CartDrawer');
            const sourceContent = doc.querySelector('#CartDrawer');

            if (cartDrawer && targetContent && sourceContent) {
              cartDrawer.classList.remove('is-empty');
              targetContent.innerHTML = sourceContent.innerHTML;
              
              const cartBubble = document.getElementById('cart-icon-bubble');
              const newCartBubble = doc.getElementById('cart-icon-bubble');
              if(cartBubble && newCartBubble) {
                  cartBubble.innerHTML = newCartBubble.innerHTML;
              }

              if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
              } else {
                  cartDrawer.classList.add('active', 'animate'); 
                  const summary = cartDrawer.querySelector('summary');
                  if(summary) summary.click();
              }
            } else {
                window.location = window.routes.cart_url;
            }
          });
      })
      .catch((e) => {
        console.error(e);
        alert("Error: " + e.message);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        submitButton.removeAttribute('aria-disabled');
        if (defaultText && originalButtonText) {
            defaultText.textContent = originalButtonText;
        }
      });
  }



      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
